import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchDispensaries} from './actions';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import AddressDisplay from "../common/AddressDisplay";

class DispensaryListPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    searchDispensaries: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
  };

  render() {
    const {
      history, searchDispensaries,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        className: 'one-line-column',
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        sorter: true,
        render: (_, {addressObj}) => <AddressDisplay address={addressObj}/>,
      },
      {
        title: 'Phone',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
        sorter: true,
        className: 'one-line-column',
      },
      {
        title: 'Action',
        key: 'action',
        className: 'one-line-column',
        render: (_, {dispensaryId}) => {
          const encodedId = encodeURIComponent(dispensaryId);
          return (
            <React.Fragment>
              <Link to={`/dispensary/update/${encodedId}`}>Edit</Link>
              {' | '}
              <Link to={`/dispensary/reporting-type-association/${encodedId}`}>Reporting types</Link>
            </React.Fragment>
          );
        },
      }
    ];
    return (
      <ListView
        title="Dispensaries"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchDispensaries}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/dispensary/add')}
        rowKey="dispensaryId"
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.dispensary.dispensaryListLoading,
  search: state.dispensary.search,
});

const mapDispatchToProps = dispatch => ({
  searchDispensaries: bindActionCreators(searchDispensaries, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DispensaryListPage);



// WEBPACK FOOTER //
// ./src/Dispensary/DispensaryListPage.js